import React from 'react';
import "./Styles/WeAreYMC.css";
import NavBar from '../NavBar';
import WeAreYMC from './Components/WeAreYMCRoute/WeAreYMC';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

import Footer from '../Footer';

function WeAreYMCRoute() {
    return (
 
            <div className="WeAreYMCRoutePage">
                <div className="WeAreYMCRouteNavBar">      
                        <NavBar/>
                     </div>
                <div className="WeAreYMCRoute">
                    <WeAreYMC/>
                </div>
                <div className="WeAreYMCContact">
                    <Footer/>
                </div>
            </div>

    );
}

export default WeAreYMCRoute;